// extracted by mini-css-extract-plugin
export default {"container":"style_container__VBLLJ","buttonsWrapper":"style_buttonsWrapper__OlepM","previous":"style_previous__xFTbi","next":"style_next__54c6S"};